// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index__1YmFsamx{height:500px}.index_content__1YmFsamx{width:100%;height:100%}", ""]);
// Exports
exports.locals = {
	"root": "index__1YmFsamx",
	"content": "index_content__1YmFsamx"
};
module.exports = exports;
